import {
  defaultFont,
} from "assets/jss/material-dashboard-pro-react";

//FUNCTIONS
import { customApp } from "functions/";

const styles = (theme) => ({
  ...defaultFont,
  menu: {
    position: 'relative',
    borderRight: customApp('color'),
  },
  menuExpanded: {
    position: 'relative',
    borderRight: customApp('color'),
  },
  button: {
    position: 'relative', float: 'left', width: '100%', padding: '7px'
  },
  avatarGroup: {
    "& .MuiAvatar-root": {
      width: "22px !important",
      height: "22px !important"
    }
  },
  buttonColor: {
    position: 'relative',
    float: 'left',
    width: 'calc(100% + 20px)',
    padding: '20px 12px',
    marginLeft: '-12px',
    display: "flex",
    justifyContent: "center",
    backgroundColor: customApp('color')
  },
  buttonColorExpanded: {
    position: 'relative',
    float: 'left',
    width: 'calc(100% + 20px)',
    padding: '20px',
    marginLeft: '-12px',
    display: "flex",
    backgroundColor: customApp('color')
  },
  separator: {
    position: 'relative',
    float: 'left',
    width: '100%',
    padding: '7px',
    borderTop: `1px solid ${customApp('medium', 0.5)}`,
    marginTop: '15px',
    marginBottom: '0px',
    height: '1px'
  }
});

export default styles;
